export default __webpack_public_path__ + "static/media/third.6007289a.png";